'use client'

import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'
import { reactPlugin } from '@datadog/browser-rum-react'
import { useEffect } from 'react'

import { useSession } from '@/shared/lib'

const botPattern = /(googlebot|bingbot|slurp|crawler|spider|bot|wget|curl)/i
const isBot = botPattern.test(navigator.userAgent)

if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'live') {
  datadogRum.init({
    applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID ?? '',
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN ?? '',
    site: 'datadoghq.com',
    service: 'samsam-web',
    env: process.env.NEXT_PUBLIC_ENVIRONMENT,
    version: process.env.NEXT_PUBLIC_DEPLOYMENT_ID, // EB 환경변수로 주입되는 값

    sessionSampleRate: isBot ? 0 : 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: 'mask-user-input',
    plugins: [reactPlugin({ router: false })],

    allowedTracingUrls: [
      {
        match: 'https://api.33m2.co.kr',
        propagatorTypes: ['tracecontext'],
      },
    ],

    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
  })

  datadogLogs.init({
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN ?? '',
    site: 'datadoghq.com',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    service: 'samsam-web',
    env: process.env.NEXT_PUBLIC_ENVIRONMENT,
    version: process.env.NEXT_PUBLIC_DEPLOYMENT_ID, // EB 환경변수로 주입되는 값
  })
}

export const DatadogRumInit = () => {
  const { data: session } = useSession()

  useEffect(() => {
    if (process.env.NEXT_PUBLIC_ENVIRONMENT !== 'live') return

    if (session?.aid) {
      datadogRum.setUser({
        id: session.aid,
        name: session.name,
        isHost: session.isHost,
      })

      return
    }

    if (!session) {
      datadogRum.clearUser()
    }
  }, [session])

  return null
}
